import { render, staticRenderFns } from "./ImageCtaSmall.vue?vue&type=template&id=bd652050&scoped=true&"
import script from "./ImageCtaSmall.vue?vue&type=script&lang=js&"
export * from "./ImageCtaSmall.vue?vue&type=script&lang=js&"
import style0 from "./ImageCtaSmall.vue?vue&type=style&index=0&id=bd652050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd652050",
  null
  
)

export default component.exports